import React from 'react';
import PropTypes from 'prop-types';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import withSounds from 'containers/withSounds';
import './GenericDropdown.css';

const NavDropdownWithSounds = withSounds({ mouseEnterSound: true })(
  NavDropdown
);

function GenericDropdown({
  format,
  className,
  withSounds,
  withHover,
  withCaret,
  rightAlign,
  mobile,
  dropdownId,
  ...rest
}) {
  const Comp = withSounds ? NavDropdownWithSounds : NavDropdown;
  const setClass = [
    'generic-dropdown',
    format && `generic-dropdown-${format}`,
    withHover && 'generic-dropdown-hover',
    withCaret && 'generic-dropdown-caret',
    rightAlign && 'generic-dropdown-right',
    mobile && 'generic-dropdown-mobile',
    className
  ]
    .filter(c => !!c)
    .join(' ');
  return (
    <Nav className={setClass}>
      <Comp id={dropdownId} {...rest} />
    </Nav>
  );
}

GenericDropdown.propTypes = {
  dropdownId: PropTypes.string.isRequired,
  className: PropTypes.string,
  format: PropTypes.string,
  withHover: PropTypes.bool,
  withSounds: PropTypes.bool,
  withCaret: PropTypes.bool,
  rightAlign: PropTypes.bool
};

GenericDropdown.defaultProps = {
  withHover: true,
  withSounds: true
};

export default GenericDropdown;
